import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { getRunsheetShiftStatus } from '../libs/getRunsheetShiftStatus'
import { getShiftsStopsFromRunsheets } from '../libs/getShiftsStopsFromRunsheets'
import { Runsheet } from '../models/runsheet/Runsheet'
import { replaceAllRunsheetShifts, upsertMultipleRunsheetShifts } from '../slices/runsheetShiftsSlice'
import { replaceAllRunsheets, upsertMultipleRunsheets } from '../slices/runsheetsSlice'
import { replaceAllRunsheetStops, upsertMultipleRunsheetStops } from '../slices/runsheetStopsSlice'

type FetchRunsheetPayload = {
  runsheetIds?: EntityId[]
}

// If scenarioIds array is empty, fetch all runsheets
export const fetchRunsheets = createAsyncThunk<void, FetchRunsheetPayload, ThunkApiContext>('runsheets/fetch', async ({ runsheetIds = [] }, { getState, dispatch }) => {
  const state = getState()
  const timezoneOffset = state.userInterface.timezoneOffset
  const runsheets = await OLMSApiService.post<Runsheet[]>('/runsheet/RunsheetList', runsheetIds)

  // To normalize data and preserve data integrity, separate shifts and scenarios before updating store
  if (runsheets && runsheets.length > 0) {
    const { shifts, stops } = getShiftsStopsFromRunsheets(runsheets)

    shifts.forEach(shift => {
      const shiftStatusContent = getRunsheetShiftStatus(shift, timezoneOffset)

      shift.status = shiftStatusContent.status
      shift.statusTooltip = shiftStatusContent.statusTooltip
    })

    // If runsheetIds array is empty, we are pulling everything and should replace all shifts and stops in the store
    if (runsheetIds.length === 0) {
      dispatch(replaceAllRunsheetShifts(shifts))
      dispatch(replaceAllRunsheetStops(stops))
    } else {
      dispatch(upsertMultipleRunsheetShifts(shifts))
      dispatch(upsertMultipleRunsheetStops(stops))
    }

    const runsheetsWithoutShifts = runsheets.map(runsheet => {
      const { shifts: excludedShifts, ...rest } = runsheet

      return rest
    })

    if (runsheetIds.length === 0) {
      dispatch(replaceAllRunsheets(runsheetsWithoutShifts))
    } else {
      dispatch(upsertMultipleRunsheets(runsheetsWithoutShifts))
    }
  }
})